import { TableCell, TableRow, Typography } from '@mui/material';
import { FC } from 'react';
import { Asset } from 'src/models';
import { formatNumber } from 'src/util/utils';
import { LaunchpadTable } from 'src/components/mui-overrides/LaunchpadTable';
import { Routes } from 'src/router/Routes';
import { useNavigate } from 'react-router-dom';
import { LinkTableCell } from 'src/components/mui-overrides/TableCell';
import { useTranslation } from 'react-i18next';

interface Props {
  secondaryAssets: Asset[];
}

export const SecondaryAssetTable: FC<Props> = ({ secondaryAssets }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const linkUrl = (asset: Asset) => {
    return Routes.ASSETS.EDIT.replace(':assetId', asset.id);
  };
  return (
    <>
      <Typography paddingBottom={'22px'} variant="h6">
        {t('dashboard.assets.secondarymarket.headline')}
      </Typography>
      <LaunchpadTable
        hidePagination={false}
        length={secondaryAssets?.length}
        renderHeader={() => {
          return (
            <TableRow>
              <TableCell>{t('dashboard.assets.secondarymarket.table.name')}</TableCell>
              <TableCell>{t('dashboard.assets.secondarymarket.table.marketvalue')}</TableCell>
              <TableCell>{t('dashboard.assets.secondarymarket.table.pricepershare')}</TableCell>
              <TableCell>{t('dashboard.assets.secondarymarket.table.totalshares')}</TableCell>
            </TableRow>
          );
        }}
        renderRows={() => {
          return (
            <>
              {secondaryAssets.map((row, index) => {
                return (
                  <TableRow key={index} hover style={{ cursor: 'pointer', textDecoration: 'none' }} onClick={() => navigate(linkUrl(row))}>
                    <LinkTableCell to={linkUrl(row)}>
                      <div style={{ fontWeight: 'bold' }}>{row.descriptions?.title}</div>
                      <div>
                        {row.location?.city}, {row.location?.countryCode}
                      </div>
                    </LinkTableCell>
                    <LinkTableCell to={linkUrl(row)}>
                      <>€{formatNumber(row.investmentDetails.sharePrice ?? 0 * (row.investmentDetails?.totalBricks ?? 0))}</>
                    </LinkTableCell>
                    <LinkTableCell to={linkUrl(row)}>
                      <> € {formatNumber(row.investmentDetails.sharePrice ?? '')} </>
                    </LinkTableCell>
                    <LinkTableCell to={linkUrl(row)}>
                      <> {row.investmentDetails.totalBricks}</>
                    </LinkTableCell>
                  </TableRow>
                );
              })}
            </>
          );
        }}
      />
    </>
  );
};
